export class Attachement{
    public id: string;
    public path: string;
    public file: string = "";
}